import { render, staticRenderFns } from "./PharmacistThreadsList.vue?vue&type=template&id=6d4a4720&"
import script from "./PharmacistThreadsList.vue?vue&type=script&lang=js&"
export * from "./PharmacistThreadsList.vue?vue&type=script&lang=js&"
import style0 from "./PharmacistThreadsList.vue?vue&type=style&index=0&id=6d4a4720&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports